import { createUseStyles, Styles } from '../../../web-styles'

interface DropdownOptionStyles {
  dropdownOption: Styles
  focusedOption: Styles
}

export const useStyles = createUseStyles<DropdownOptionStyles>((theme) => {
  return {
    dropdownOption: {
      display: 'flex',
      width: '100%',
      padding: theme.calcUnit(theme.spacing.s2),
      cursor: 'pointer',
      gap: theme.calcUnit(theme.spacing.s2),
      alignItems: 'center',
      borderRadius: theme.borderRadius.roundedDefault,
      '&:hover': {
        backgroundColor: theme.colors.webFadedBackground,
      },
    },
    focusedOption: {
      backgroundColor: theme.colors.webFadedBackground,
    },
  }
})
